// Props that make a non-button element (a card, a tile) act like a button:
// clickable, focusable, and opened with Enter or Space.
// Spread onto the element: <div {...clickableProps(() => open())} className="...">
export const clickableProps = (onClick, label) => (typeof onClick === 'function' ? {
  role: 'button',
  tabIndex: 0,
  'aria-label': label || undefined,
  onClick,
  onKeyDown: (e) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  },
} : {});

// Hover styling for a clickable card or tile.
export const CLICKABLE_CARD = 'cursor-pointer hover:shadow-md hover:ring-2 hover:ring-blue-200 dark:hover:ring-blue-800/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 transition-shadow';

// Link styling for clickable text.
export const LINK_TEXT = 'text-blue-600 dark:text-blue-400 hover:underline cursor-pointer focus:outline-none focus-visible:underline';

// Stop a click inside a clickable card from also opening the card.
export const stop = (e) => { if (e && e.stopPropagation) e.stopPropagation(); };
